export const SET_NODE_LIST = 'SET_NODE_LIST';
export const setNodeList = (data) => ({
  type: SET_NODE_LIST,
  node: data,
});

export const SET_ERROR = 'SET_ERROR';
export const setError = (value) => ({
  type: SET_ERROR,
  value,
});
